class RefreshMemoryUserInfo {
  private supportChannel = false
  private callback: () => void
  private bc: BroadcastChannel | null = null

  constructor() {
    this.supportChannel = !!window.BroadcastChannel
    if (this.supportChannel) {
      this.bc = new BroadcastChannel('RefreshMemoryUserInfo')
      this.bc.addEventListener('message', () => {
        if (this.callback) {
          this.callback()
        }
      })
    }
  }

  setHydrateCallback(cb: () => void) {
    this.callback = cb
  }

  trigger() {
    if (this.bc) {
      this.bc.postMessage('trigger')
    }
  }
}

const refreshMemoryUserInfo = new RefreshMemoryUserInfo()

export { refreshMemoryUserInfo }
